import { render, staticRenderFns } from "./CmgPickupOptionsModal.vue?vue&type=template&id=6c54743a&scoped=true&lang=pug&"
import script from "./cmg-pickup-options-modal.ts?vue&type=script&lang=ts&"
export * from "./cmg-pickup-options-modal.ts?vue&type=script&lang=ts&"
import style0 from "./CmgPickupOptionsModal.vue?vue&type=style&index=0&id=6c54743a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c54743a",
  null
  
)

export default component.exports